import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const imgUrl = (src) => (!src ? "" : src.startsWith("/api/") ? `${BACKEND}${src}` : src);

export const eur = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n || 0));

const DE_ERR = {
  "Invalid code": "Ungültiger Code.", "Password or code incorrect": "Passwort oder Code falsch.",
  "Current password is incorrect": "Aktuelles Passwort ist falsch.", "Password must contain letters and numbers": "Das Passwort braucht Buchstaben und Zahlen.",
  "Password must be 8-128 characters": "Das Passwort muss 8–128 Zeichen lang sein.", "Password is too easy to guess": "Dieses Passwort ist zu leicht zu erraten.",
  "Link is invalid or expired": "Der Link ist ungültig oder abgelaufen.", "Too many requests. Please try again later.": "Zu viele Versuche – bitte warte kurz.",
  "Invalid email or password": "E-Mail oder Passwort falsch.", "Email already registered": "Diese E-Mail ist bereits registriert.",
  "Email is temporarily unavailable": "E-Mail-Versand ist gerade nicht verfügbar – bitte versuche es gleich noch einmal.",
  "Sign-in expired, please log in again": "Anmeldung abgelaufen – bitte erneut einloggen.", "2FA is required for admin accounts": "2FA ist für Admin-Konten Pflicht.",
  "SKU already used by another product": "Diese SKU wird bereits von einem anderen Produkt verwendet.",
  "Language edition is required (DE, EN, JA, ZH-CN, ZH-TW, KO)": "Bitte eine Sprach-Edition wählen (DE, EN, JA, ZH-CN, ZH-TW, KO).",
  "Too many attempts. Try again in 15 minutes.": "Zu viele Versuche. Bitte in 15 Minuten erneut versuchen.",
};

export function errMsg(e) {
  const de = (localStorage.getItem("pn28_lang") || "de") === "de";
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  if (typeof d === "string" && de && DE_ERR[d]) return DE_ERR[d];
  if (typeof d === "string" && de && d.startsWith("Cannot publish – missing:")) return d.replace("Cannot publish – missing:", "Veröffentlichen nicht möglich – es fehlt:");
  if (status >= 500 || (!d && status)) return de ? "Der Server ist gerade nicht erreichbar – bitte versuche es gleich noch einmal." : "The server is unavailable right now – please try again shortly.";
  if (!d) return e?.message || "Error";
  if (typeof d === "string") return (de && DE_ERR[d]) || d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const INSTAGRAM_URL = "https://www.instagram.com/";
export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/7e09a981-f25d-4bee-a6b0-8e6f5a9cddd0/images/2442059cd396e1cd44b7e59ccc9eccd99b67d85e780b666c932f9552260bf6a1.jpeg";
